import React from 'react';
import PropTypes from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import {Dropdown, SingleText} from '@/web-components';
export const ProjectStatusColumnDropdown = ({
	columns,
	dropdownAlignment,
	width,
	name,
	selectedItems,
	optionsName,
	onSelect,
	onRemove,
	selectedGroupName,
	isProjectGroup,
	userpilot,
	emphasizeEmptyState,
	headerLines,
}) => {
	return (
		<Dropdown
			isNested
			isMultiSelect
			headerLines={headerLines}
			selectedGroupName={selectedGroupName}
			selectedItems={selectedItems}
			width={width}
			dropdownAlignment={dropdownAlignment}
			name={name}
			onSelect={onSelect}
			onRemove={onRemove}
			userpilot={userpilot}
			emphasizeEmptyState={emphasizeEmptyState}
		>
			<Dropdown.Group name={optionsName} key={'dropdown-options'}>
				{columns
					.sort((a, b) => (a.node.order > b.node.order ? 1 : -1))
					.map(edge => {
						const {id, name, projectGroupStatusColumnId} = edge.node;
						return (
							<SingleText key={id} value={isProjectGroup ? projectGroupStatusColumnId : id} searchString={name}>
								{name}
							</SingleText>
						);
					})}
			</Dropdown.Group>
		</Dropdown>
	);
};

ProjectStatusColumnDropdown.propTypes = {
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			node: PropTypes.shape({
				name: PropTypes.string.isRequired,
				id: PropTypes.string.isRequired,
			}),
		})
	).isRequired,
	dropDownAlignment: PropTypes.oneOf(['left', 'center', 'right']),
	width: PropTypes.number,
	name: PropTypes.string,
	optionsName: PropTypes.string,
	selectedItems: PropTypes.array,
	onSelect: PropTypes.func,
	onRemove: PropTypes.func,
	selectedGroupName: PropTypes.string,
	headerLines: PropTypes.element,
};

ProjectStatusColumnDropdown.defaultProps = {
	optionsName: 'Status Colums',
	name: 'Status Colums',
	selectedGroupName: 'Selected',
	onSelect: () => false,
	onRemove: () => false,
};

export default createFragmentContainer(ProjectStatusColumnDropdown, {
	columns: graphql`
		fragment ProjectStatusColumnDropdown_columns on StatusColumnV2TypeEdge @relay(plural: true) {
			node {
				order
				name
				id
				projectGroupStatusColumnId
			}
		}
	`,
});
